import * as types from '../../actions/actionTypes';

const defaultState = {
  appLoaded: false,
  isLoading: false,
  isAuthenticated: false,
  appName: 'Non Cash Deposit Portal',
  token: null,
  currentUser: {},
};

export default (state = defaultState, action) => {
  switch (action.type) {
    case types.APP_LOAD:
      return {
        ...state,
        isLoading: action.isLoading,
        token: action.token || null,
        appLoaded: true,
        isAuthenticated: false,
        currentUser: action.data,
      };
    case types.SET_LOGIN_SUCCESS:
      return {
        ...state,
        redirectTo: '/home',
        cognitoUser: action.user,
        token: action.token,
        currentUser: action.data,
        isAuthenticated: true,
        isLoading: action.isLoading,
      };
    case types.SET_LOGIN_ERROR:
      return {
        ...state,
        redirectTo: null,
        error: action.error,
        isAuthenticated: false,
        isLoading: action.isLoading,
      };
    case types.SET_DISABLE_USER_SIGNIN:
      return {
        ...state,
        redirectTo: null,
        message: action.data,
        isAuthenticated: false,
        isLoading: action.isLoading,
      };
    case types.UNAUTH_USER:
      return {
        error: 'Not Authorized',
        isAuthenticated: false,
        isLoading: false,
      };

    case types.REDIRECT:
      return { ...state, redirectTo: null };
    case types.SET_SEND_EMAIL_SUCCESS:
      return {
        ...state,
        emailSent: action.data,
      };
    case types.RESET: {
      return {
        message: undefined,
        error: undefined,
      };
    }
    case types.SET_REMOVE_ERROR: {
      return {
        ...state,
        isLoading: false,
        error: undefined,
        message: undefined,
      };
    }
    default:
      return state;
  }
};
